import { Navigate } from "react-router-dom";
import { applySearchParamsToPath } from "../../utils/url.ts";

export const PreserveSearchNavigate = ({
  to,
  replace = false,
}: {
  to: string;
  replace?: boolean;
}) => <Navigate to={applySearchParamsToPath(to)} replace={replace} />;
